import React, { PropTypes, Component } from 'react';
import { FlatButton, MenuItem, Popover, Toggle } from 'material-ui';
import ArrowDropDownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import FlatDropDownMenu from '../tc-ui/flatDropDownMenu';
import TcDayPicker from '../tc-ui/date-picker';
import moment from 'moment';
import R from 'ramda';

const convertToYY = ({ startDate, endDate }) => startDate && endDate ? `${moment.utc(startDate).format('D MMM YYYY')} - ${moment.utc(endDate).format('D MMM YYYY')}` : '';
const propTypes = {
  outerDivStyle: PropTypes.object,
  arrayOfYears: PropTypes.array,
  onDropdownChange: PropTypes.func,
  selectedYearRange: PropTypes.string,
  showAllPeriods: PropTypes.bool,
  selectAllPeriods: PropTypes.func,
  currentPeriod: PropTypes.object,
};

class YearDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      allPeriodsChecked: false,
      fromDate: props.currentPeriod.startDate,
      toDate: props.currentPeriod.endDate,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (!(this.props.currentPeriod && this.props.currentPeriod.startDate) && (nextProps.currentPeriod.startDate)) {
      this.setState({
        allPeriodsChecked: nextProps.selectedYearRange === 'All Periods',
        fromDate: nextProps.currentPeriod.startDate,
        toDate: nextProps.currentPeriod.endDate,
      });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  togglePopover = open => (e) => {
    this.setState({ open, anchorEl: e ? e.currentTarget : null });
  };
  render() {
    const {
      arrayOfYears,
      outerDivStyle,
      selectedYearRange,
      onDropdownChange,
      showAllPeriods,
      selectAllPeriods,
    } = this.props;
    const {
      allPeriodsChecked,
      fromDate,
      toDate,
    } = this.state;
    return (
      <div style={outerDivStyle}>
        <FlatButton
          label={selectedYearRange}
          labelPosition="before"
          onTouchTap={this.togglePopover(true)}
          icon={<ArrowDropDownIcon style={{ fill: 'white' }}/>}
          style={{ borderRadius: '4px' }}
          labelStyle={{ textTransform: 'none', color: 'white', fontSize: '18px' }}
        />
        <Popover
          open={this.state.open}
          onRequestClose={this.togglePopover(false)}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        >
          <div style={{ padding: '24px 0 8px 24px' }}>
            {
              showAllPeriods ? (
                <Toggle
                  label="All Periods"
                  toggled={allPeriodsChecked}
                  onToggle={(_, val) => this.setState({ allPeriodsChecked: val })}
                  style={{ width: '150px' }}
                />
              ) : undefined
            }
            {
              // arrayOfYears.map((yearObj, i) => {
              //   return (
              //     <MenuItem
              //       key={i}
              //       value={convertToYY(yearObj)}
              //       primaryText={convertToYY(yearObj)}
              //       onTouchTap={() => onDropdownChange(yearObj)}
              //     />
              //   );
              // })
            }
            <TcDayPicker
              data-cy="fromDate"
              disabled={showAllPeriods && allPeriodsChecked}
              containerStyle={{ display: 'inline-block', verticalAlign: 'top' }}
              textFieldStyle={{ width: '100%' }}
              onChange={(date) => this.setState({ fromDate: date })}
              value={fromDate}
              initialMonth={fromDate || toDate}
              floatingLabelText="From Date"
              closeOnSelect
            />
            <TcDayPicker
              data-cy="toDate"
              disabled={showAllPeriods && allPeriodsChecked}
              containerStyle={{ display: 'inline-block', marginLeft: '24px', verticalAlign: 'top' }}
              textFieldStyle={{ width: '100%' }}
              onChange={(date) => this.setState({ toDate: date })}
              value={toDate}
              enableFrom={fromDate}
              initialMonth={toDate || fromDate}
              floatingLabelText="To Date"
              closeOnSelect
            />
          </div>
          <div style={{ margin: '0 0 12px 12px' }}>
            <FlatButton
              label="Apply"
              secondary
              onTouchTap={() => {
                if (allPeriodsChecked) selectAllPeriods();
                else onDropdownChange({ startDate: fromDate, endDate: toDate });
                this.setState({ open: false });
              }}
            />
          </div>
        </Popover>
      </div>
    );
  }
}

YearDropdown.propTypes = propTypes;

export default YearDropdown;



// WEBPACK FOOTER //
// ./src/app/components/contracting/yearDropdown.jsx